<template>
  <div class="qc-platform-ui qc-hw">
    <div v-if="forgotPasswordShow">
      <ForgotPassword
        :onClose="onColseForgotPassword" />
    </div>
    <div v-else>
      <Account
        :openForgotPassword="onOpenForgotPassword"
        :autoDown="props.autoDownConfig.account"
        :clientId="props.clientId"
        :onClose="props.onClose"
        :onFinish="props.onFinish" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import Account from './Account.vue';
import ForgotPassword from './ForgotPassword.vue';
import type { InternationalLoginProps } from '../types';

const props = withDefaults(defineProps<InternationalLoginProps>(), {});

const forgotPasswordShow = ref(false);
const onColseForgotPassword = () => {
  forgotPasswordShow.value = false;
};
const onOpenForgotPassword = () => {
  forgotPasswordShow.value = true;
};

</script>